import type { PersonInvolvement } from "../types/involvement.js";
import type { UserId } from "../types/user.js";
import { isInvolvementLive } from "./isInvolvementLive.js";

/**
 * Who approves this assessor's work: the party of the live approver
 * involvement naming them that conveys `approve`, or `undefined` while there is
 * none.
 *
 * An involvement outlives its holder's role: one whose holder has left the
 * organisation it is held on behalf of, or holds no role there that approves,
 * stays live but conveys nothing, and whoever holds it could never decide.
 */
export const approverPartyForAssessor = <
  R extends Pick<
    PersonInvolvement,
    "kind" | "party" | "approvesUserId" | "endedAt" | "expiresAt" | "actions"
  >,
>(
  involvements: readonly R[],
  assessorUserId: UserId,
  now: Date = new Date(),
): R["party"] | undefined =>
  involvements.find(
    (involvement) =>
      involvement.kind === "approver" &&
      involvement.approvesUserId === assessorUserId &&
      isInvolvementLive(involvement, now) &&
      involvement.actions.includes("approve"),
  )?.party;
